export default "__VITE_ASSET__B6mprUzH__"